import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ContactForm from "@/components/feature/ContactForm";
import { useSeo } from "@/hooks/useSeo";

const contactWays = [
  {
    icon: "ri-lightbulb-line",
    title: "提供热点线索",
    desc: "附上可核验的公开链接、截图或视频来源，会大大提高被采纳的概率。",
  },
  {
    icon: "ri-team-line",
    title: "内容合作",
    desc: "选题共创、内容授权与长期合作都可以聊，请在来意中选择「内容合作」。",
  },
  {
    icon: "ri-error-warning-line",
    title: "纠错与反馈",
    desc: "如果文中存在事实偏差或表述问题，欢迎指出，我们核实后会及时修订。",
  },
];

export default function Contact() {
  useSeo({
    title: "联系我们 - 黑料吃话线索投稿与合作通道",
    description:
      "联系黑料吃话：提供娱乐热点线索、申请内容合作、反馈纠错或咨询订阅问题。附上可核验来源的线索会被优先处理，我们通常在两个工作日内回复。",
    keywords: "黑料吃话,联系我们,黑料吃话投稿,线索提供,内容合作,纠错反馈",
    path: "/contact",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: "联系黑料吃话",
        description: "线索投稿、内容合作与纠错反馈的联系通道",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: `${window.location.origin}/` },
          { "@type": "ListItem", position: 2, name: "联系我们", item: `${window.location.origin}/contact` },
        ],
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "联系我们" }]} />

      <main className="flex-1">
        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-8">
            <span className="text-xs font-medium tracking-[0.24em] text-primary-600">CONTACT</span>
            <h1 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">联系我们</h1>
            <p className="mt-4 max-w-2xl text-sm leading-8 text-foreground-600">
              有线索、有疑问，或者想一起做点内容，都可以在这里找到我们。填写表单后我们会在两个工作日内回复。
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-8">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
              <div className="lg:col-span-7">
                <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
                  <h2 className="font-heading text-xl font-bold text-foreground-950">在线留言</h2>
                  <p className="mt-2 text-sm leading-7 text-foreground-600">
                    带 * 的为必填项。请尽量把信息写清楚，方便我们快速核实。
                  </p>
                  <div className="mt-6">
                    <ContactForm />
                  </div>
                </div>
              </div>

              <aside className="lg:col-span-5">
                <div className="rounded-lg border border-background-200 bg-background-100 p-6">
                  <h2 className="font-heading text-lg font-bold text-foreground-950">直接邮件</h2>
                  <p className="mt-3 text-sm leading-7 text-foreground-600">
                    不方便填表时，也可以直接发邮件给我们。
                  </p>
                  <a
                    href="mailto:contact@heiliaochihua.example"
                    className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-primary-700 underline-offset-4 hover:underline"
                  >
                    <i className="ri-mail-line"></i>contact@heiliaochihua.example
                  </a>
                </div>

                <div className="mt-6 space-y-4">
                  {contactWays.map((way) => (
                    <div key={way.title} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
                      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100">
                        <i className={`${way.icon} text-xl text-secondary-700`}></i>
                      </span>
                      <div>
                        <h3 className="font-heading text-base font-bold text-foreground-950">{way.title}</h3>
                        <p className="mt-1.5 text-sm leading-7 text-foreground-600">{way.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-6 rounded-lg bg-secondary-900 p-6">
                  <i className="ri-shield-check-line text-2xl text-accent-300"></i>
                  <h2 className="mt-3 font-heading text-base font-bold text-background-50">关于隐私</h2>
                  <p className="mt-2 text-sm leading-7 text-secondary-200">
                    你提交的信息仅用于回复本次来意，不会被公开或用于其他用途。匿名线索我们也会尽量保护来源。
                  </p>
                </div>
              </aside>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}